var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { attrs: { id: "commonTable" } },
    [
      _c(
        "el-main",
        [
          _c(
            "el-table",
            {
              style: { width: _vm.tableWidth },
              attrs: {
                data: _vm.data,
                height: _vm.height,
                "max-height": _vm.maxHeight,
                border: "",
                "tooltip-effect": "light",
                "header-cell-style": { background: "#f6f8f9" },
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _vm.showCheckBox
                ? _c("el-table-column", {
                    attrs: { type: "selection", width: "45" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.columns, function (item, index) {
                return [
                  item.show !== false
                    ? _c("el-table-column", {
                        key: index,
                        attrs: {
                          fixed: item.fixed,
                          prop: item.prop,
                          label: item.label,
                          align: item.align ? item.align : "center",
                          width: item.width,
                          "show-overflow-tooltip": true,
                          formatter: item.formatter
                            ? item.formatter
                            : _vm.formatterValue,
                        },
                      })
                    : _vm._e(),
                ]
              }),
              _vm._v(" "),
              _vm.showOperationColumn
                ? [
                    _c("el-table-column", {
                      attrs: { fixed: "right", label: "操作", width: "150" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._t("table_operation", null, {
                                  scope: scope,
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showPagination
        ? _c(
            "el-footer",
            {
              staticStyle: {
                height: "42px",
                "padding-top": "6px",
                background: "white",
              },
              attrs: { id: "simpleTableFooter" },
            },
            [
              _c("el-pagination", {
                staticStyle: { "text-align": "right", margin: "0" },
                attrs: {
                  "current-page": _vm.pagination.pageNo,
                  "page-size": _vm.pagination.limit,
                  "page-sizes": _vm.pagination.sizes,
                  total: _vm.pagination.total,
                  layout: "total, prev, pager, next, jumper",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }